<!--
/*******************************************************************************
*@ 컴포넌트명   : SearchTag.vue
*@ 컴포넌트설명 : 검색조건에 사용되는 태그 검색 template
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <li>
    <span class="item" @click="remove">
      <em>#</em>
      {{text}}
      <i class="icon icon-close" />
    </span>
  </li>
</template>
<script>
export default {
  props: {
    text: String,
    index: Number,
  },
  methods: {
    remove() {
      this.$emit("remove", this.index);
    },
  },
};
</script>